import { ReactNode, createContext, useState } from 'react';

import { OpenedTabsState, OpenedItemsState, PathState } from 'types/menu';
import { navConfig } from 'layouts/dashboard/navbar/NavConfig';

const initialPath = { tab: null, item: null, subitem: null } as PathState;

const initialTabs = navConfig.reduce((acc, tab) => {
  acc[tab.subheader] = false;
  return acc;
}, {} as OpenedTabsState);

const initialItems = navConfig.reduce((acc, tab) => {
  if (!tab.items) return acc;

  tab.items.forEach((item) => {
    if (!item.items) return;

    acc[item.title] = null;
  });

  return acc;
}, {} as OpenedItemsState);

export type CollapseDrawerContextProps = {
  opened: boolean;
  hovered: boolean;
  tabs: OpenedTabsState;
  items: OpenedItemsState;
  path: PathState;
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
  setHovered: React.Dispatch<React.SetStateAction<boolean>>;
  setTabs: React.Dispatch<React.SetStateAction<OpenedTabsState>>;
  setItems: React.Dispatch<React.SetStateAction<OpenedItemsState>>;
  setPath: React.Dispatch<React.SetStateAction<PathState>>;
};

const initialState: CollapseDrawerContextProps = {
  opened: true,
  hovered: true,
  tabs: initialTabs,
  items: initialItems,
  path: initialPath,
  setOpened: () => {},
  setHovered: () => {},
  setTabs: () => {},
  setItems: () => {},
  setPath: () => {},
};

const CollapseDrawerContext = createContext(initialState);

type CollapseDrawerProviderProps = {
  children: ReactNode;
};

function CollapseDrawerProvider({ children }: CollapseDrawerProviderProps) {
  const [opened, setOpened] = useState(true);
  const [tabs, setTabs] = useState(initialTabs);
  const [items, setItems] = useState(initialItems);
  const [hovered, setHovered] = useState(false);
  const [path, setPath] = useState(initialPath);

  return (
    <CollapseDrawerContext.Provider
      value={{
        opened: opened,
        hovered: hovered,
        tabs: tabs,
        items: items,
        path: path,
        setOpened: setOpened,
        setHovered: setHovered,
        setTabs: setTabs,
        setItems: setItems,
        setPath: setPath,
      }}
    >
      {children}
    </CollapseDrawerContext.Provider>
  );
}

export { CollapseDrawerProvider, CollapseDrawerContext };
